import MdaeDataGrid from "./component";
import {
  IDataGridOptions,
  ISearchPanelProps,
  IColumnProps,
  IColumnChooserProps,
  IColumnFixingProps,
} from "devextreme-react/data-grid";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
import { Export, StateStoring } from "devextreme/ui/data_grid";
import { DataGridCell } from "devextreme/excel_exporter";
interface IMdaeDataGridSearchPanelProps extends ISearchPanelProps {}
export interface IMdaeDataGridColumnProps extends IColumnProps {}
interface IMdaeColumnChooserProps extends IColumnChooserProps {
  isMdaeColumnChooserVisible?: boolean;
}
interface IMdaeColumnFixingProps extends IColumnFixingProps {}
export const mandatoryPropNames = ["id"];

export interface IMdaeExport extends Export {
  fileName?: string;
  customizeExcelCell?: (options: {
    gridCell?: DataGridCell;
    excelCell?: any;
  }) => void;
  beforeExporting?: (e: { component?: any }) => void;
  afterExporting?: (e: { component?: any }) => void;
}
export interface IMdaeStateStoring extends StateStoring {
  isGetGridSettingCalled?: boolean;
  isUserTaskDataGrid?: boolean;
  onBeforeLoadGridState?: (state: any) => void;
}
export interface IMdaeDataGridProps extends IDataGridOptions {
  id: string;
  mdaeColumns?: Array<IMdaeDataGridColumnProps>;
  mdaeSearchPanel?: IMdaeDataGridSearchPanelProps;
  mdaeColumnChooser?: IMdaeColumnChooserProps;
  mdaeColumnFixing?: IMdaeColumnFixingProps;
  mdaeDataGridCustomButtons?: any;
  clearFilterButtonId?: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
  pageSize?: number;
  mdaeDataGridCustomButtonsBefore?: any;
  mdaeDataGridCustomButtonsEnd?: any;
  onDataGridClearFilterClick?: any;
  export?: IMdaeExport;
  mdaeStateStoring?: IMdaeStateStoring;
}
export default MdaeDataGrid;
